import React, { useEffect, useState } from 'react'
import '../components/landing/landing.scss'
import axios from 'axios';
import { FadeLoader } from 'react-spinners';
import {  useNavigate } from 'react-router-dom';
import '../components/global/global.scss'

function VerifyPage() {
    const [isProcessing, setIsProcessing] = useState(false);
    const [businessName, setBusinessName] = useState('Flick');
    const [avatarUrl, setAvatarUrl] = useState('/favicon.ico'); // Default favicon
    useEffect(()=>{
        authUrl();
        // eslint-disable-next-line
    },[])
    const navigate = useNavigate();

    const updateFaviconAndTitle = async (name, iconUrl) => {
      document.title = name;
     

      let link = document.querySelector("link[rel='icon']");
      if (!link) {
          link = document.createElement("link");
          link.setAttribute("rel", "icon");
          document.head.appendChild(link);
      }
      link.setAttribute("href", iconUrl);
  };

    

    const authUrl = async ()=>{

        setIsProcessing(true)
        const params  = window.location.href;
        const urlId = params.split('/');
        const id = urlId[urlId.length-1]

        
       
        try {
          const url = `https://zfhybscbs0.execute-api.us-east-2.amazonaws.com/production/payment-page-authenticator/${id}`;
          const res = await axios.get(url)
          console.log("verify",res.data)

          const {cbInfo} = res.data?.data
          const {redirectLink} =res.data?.data
          const {isUserAuthRequired} = res.data
          const result = res?.data
          const strResult = JSON.stringify(result);
          localStorage.setItem("auth",strResult);
          
          if (res.data.total_whitelabelling) {
            const businessName = res.data?.data?.business_name || "Custom Business";
            const avatar = res.data?.avatar || "/favicon.ico"; // Ensure valid favicon path

            setBusinessName(businessName);
            setAvatarUrl(avatar);

           
            updateFaviconAndTitle(businessName, avatar);
          }
          
          localStorage.setItem("redirect",redirectLink)
          // localStorage.setItem('transfer', result?.transactionId);      

          if(res?.data?.verificationStatus==="verified"){
            if(res?.data?.data?.source === "dashboard" ){
               navigate('/pages/dashboard')
               setIsProcessing(false)
               return
            }else if(res?.data?.data?.source === "api"){
              if(res?.data?.IsCompletedPayment) return navigate('/invalid')
              
              if(cbInfo.currency_collected ==="USD" && cbInfo.currency_settled==="USD" ){
                setIsProcessing(false)
                return navigate('/pages/global-payment')
              }else if((cbInfo.currency_collected === "EUR" || cbInfo.currency_collected === "GBP" || cbInfo.currency_collected === "USD" ) && (cbInfo.currency_settled==="EUR" || cbInfo.currency_settled==="GBP" || cbInfo.currency_settled==="USD" ) ){
                setIsProcessing(false)
                if(!isUserAuthRequired){
                  return navigate('/pages/payment-credential')
                }else{
                  return navigate('/pages/global-payment')
                }
              }else if(cbInfo.currency_settled==="CAD" || cbInfo.currency_collected === "CAD"){

                setIsProcessing(false)
                if(!isUserAuthRequired){
                  return navigate('/pages/canada')
                }else{
                  return navigate('/pages/global-payment')
                }
                
              }
              else{
                return navigate('/invalid')
              }
            }

            // const transactionId = await createId();
          }

          else if(res?.data?.verificationStatus!=="verified" || res?.data?.IsCompletedPayment) {
            return navigate('/invalid')
          }
    
        } catch(error) {
         return navigate('/invalid')
          
        }
    }
  return (
    <div className="loader">
          <div className='loading_overlay' style={{background:"#e9e9e9"}}>
             
                {
                    isProcessing
                    &&
                    <FadeLoader
                    cssOverride={{marginRight:"auto",marginLeft:"auto"}}
                    color="#259792"
                    />
                }
              
          </div>
   </div>
  )
}

export default VerifyPage
